import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { formatINR, finalPrice } from '../utils/priceFormat';

const PH = 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=400&q=70';

// Track recently viewed
function trackViewed(product) {
  try {
    const key = 'vkg_recently_viewed';
    const raw  = localStorage.getItem(key);
    const list = raw ? JSON.parse(raw) : [];
    const filtered = list.filter(p => p.id !== product.id);
    const updated  = [{ id:product.id, slug:product.slug, name:product.name, photo:product.photo||(product.photos?.[0]||''), selling_price:product.selling_price, discount_pct:product.discount_pct }, ...filtered].slice(0, 12);
    localStorage.setItem(key, JSON.stringify(updated));
  } catch {}
}

export default function ProductCard({ product }) {
  const navigate      = useNavigate();
  const { addToCart } = useCart();
  const { user }      = useAuth();

  const price = finalPrice(product.selling_price, product.discount_pct);

  const photo = (() => {
    const raw = product.photo || (Array.isArray(product.photos) && product.photos[0]) || '';
    if (!raw) return PH;
    if (raw.startsWith('http')) return raw;
    return 'https://shop.demo.example.com/' + raw.replace(/^\/+/, '');
  })();

  const handleClick = () => { trackViewed({...product, photo}); navigate(`/product/${product.slug}`); };

  const handleAddToCart = async (e) => {
    e.stopPropagation();
    if (!user) { toast.error('Please login to add to cart'); navigate('/login'); return; }
    try { await addToCart(product.id, 1); toast.success('Added to cart! 🛒'); }
    catch (err) { toast.error(err.message); }
  };

  const handleWishlist = async (e) => {
    e.stopPropagation();
    if (!user) { toast.error('Please login'); navigate('/login'); return; }
    try { await api.post('/wishlist', { product_id: product.id }); toast.success('Saved to wishlist ❤️'); }
    catch (err) { toast.error(err.message); }
  };

  return (
    <div className="product-card" onClick={handleClick}>
      <div className="product-card-image">
        <img src={photo} alt={product.name} onError={e => { e.target.src = PH; }} loading="lazy"/>
        {product.is_new && !product.discount_pct  && <span className="product-card-badge badge-new">New</span>}
        {product.discount_pct > 0                 && <span className="product-card-badge badge-sale">-{product.discount_pct}%</span>}
        {product.featured && !product.is_new && !product.discount_pct && <span className="product-card-badge badge-featured">Featured</span>}
        <div className="product-card-actions">
          <button className="icon-btn" onClick={handleWishlist} title="Wishlist">❤️</button>
          <button className="icon-btn" onClick={handleAddToCart} title="Add to Cart">🛒</button>
          <button className="icon-btn" onClick={e=>{ e.stopPropagation(); handleClick(); }} title="View">👁️</button>
        </div>
      </div>
      <div className="product-card-body">
        {product.category_name && <div className="product-card-cat">{product.category_name}</div>}
        <div className="product-card-name" title={product.name}>{product.name}</div>
        <div className="product-card-subtitle">Traditional Saree Collection</div>
        {product.material && <div className="product-card-material">{product.material}</div>}

        <div className="product-card-price-row">
          <div className="product-card-price">
            <span className="product-card-price-main">₹{formatINR(price)}</span>
            {product.discount_pct > 0 && <>
              <span className="product-card-price-old">₹{formatINR(product.selling_price)}</span>
              <span className="product-card-price-off">{product.discount_pct}% OFF</span>
            </>}
          </div>
        </div>

        {(product.avg_rating > 0 || product.stock_qty <= 5) && (
          <div className="product-card-meta">
            {product.avg_rating > 0 && (
              <div className="product-card-rating">
                <span className="stars stars-sm">{'★'.repeat(Math.round(product.avg_rating))}</span>
                <span className="product-card-review-count">({product.review_count||0})</span>
              </div>
            )}
            {product.stock_qty <= 5 && product.stock_qty > 0 && <div className="product-card-stock low">Only {product.stock_qty} left</div>}
          </div>
        )}

        {product.stock_qty === 0 && <div className="product-card-stock out">Currently Unavailable</div>}
      </div>
    </div>
  );
}
